// extracted by mini-css-extract-plugin
export default {"container":"PageTeam_container__K8uHn","name":"PageTeam_name__44lPY","title":"PageTeam_title__IlbFD","btn":"PageTeam_btn__pHH4u"};